<template>
  <Section id="step-two" type="dark">
    <Counter>2</Counter>
    <Heading>Get the raw export data</Heading>
    <Description>
      Paste Discord API key to the form below to export your channel and user lists.
      <slot />
    </Description>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'
  import Counter from './UI/Counter'

  export default {
    components: {
      Section,
      Heading,
      Description,
      Counter
    }
  }
</script>

<style lang="scss" scoped>
  
</style>
